import { render } from "./App.vue?vue&type=template&id=f790e8a0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f790e8a0&lang=scss"

import exportComponent from "/Users/anxin/Documents/Vue/河南Vue网站/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__